<!-- 新闻列表 -->
<template>
  <div class="component-news-list">
    <div class="all-content">
      <div class="title">
        <div class="bigtitle">
          <span class="titlestyle">英雄之名·</span>共同捍卫
        </div>
        <div class="more">
          <router-link
            :to="{ path: '/newslist', query: { type: gthwnum } }"
            class="slide-item-content"
            target="_blank"
          >
            更多>>
          </router-link>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li
            @click="num = 1"
            class="tabnoactive def-hover-trs"
            :class="{ tabactive: num === 1 }"
          >
            政策法规
          </li>
          <li
            @click="num = 2"
            class="tabnoactive def-hover-trs"
            :class="{ tabactive: num === 2 }"
          >
            经验做法
          </li>
        </ul>
      </div>
      <div class="list">
        <!-- 政策法规 -->
        <ul v-show="num === 1">
          <li
            class="titlehang2 def-hover-trs yuanli"
            v-for="(item, index) in zcfg"
            :key="index"
          >
            <a
              :href="
                'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                  item.basicId
              "
              target="_blank"
            >
              {{ item.basicTitle }}
            </a>
          </li>
          <li></li>
        </ul>
        <!-- 经验做法 -->
        <ul v-show="num === 2">
          <li
            class="titlehang2 def-hover-trs yuanli"
            v-for="(item, index) in jyzf"
            :key="index"
          >
            <a
              :href="
                'http://yinglie.chinamartyrs.gov.cn/zhylw/zcfg/content.html?id=' +
                  item.basicId
              "
              target="_blank"
            >
              {{ item.basicTitle }}
            </a>
          </li>

          <li></li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ComponentNewsList",
  data() {
    return {
      num: 1
    };
  },
  props: ["zcfg", "jyzf", "gthwnum"],
  methods: {}
};
</script>

<!-- 组件独有样式 -->
<style scoped>
.slide-item-content {
  color: #000;
}
.slide-item-content:hover {
  color: var(--main-color);
}
.component-news-list {
  width: 1200px;
  min-width: 1200px;
  /* height: 540px; */
  background-color: rgb(255, 255, 255);
  border-radius: 15px;
  margin-top: 12px;
}
.all-content {
  width: 1140px;
  /* height: 700px; */
  position: relative;
  margin: 0 auto;
  top: 10px;
}
.title,
.tab,
.list {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.title {
  line-height: 15px;
}
.list {
  /* height: 360px; */
  padding-bottom: 60px;
  top: 50px;
  /* background-color: rgb(168, 192, 192); */
}

.list ul {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 0;
}
.list ul li {
  width: 320px;
  padding-top: 10px;
  margin-bottom: 8px;
  font-size: 17.34px;
  line-height: 1.5em;
}
.yuanli {
  border-bottom: 1.5px solid #ddd;
}
.list ul .yuanli:hover {
  cursor: pointer;
  color: var(--main-color);
  border-bottom: 1.5px solid var(--main-color);
}
.list ul .yuanli a {
  color: #000;
}
.list ul .yuanli a:hover {
  color: var(--main-color);
}
/* .list ul .yuanli:before {
  content: "●";
  color: #ddd;
  float: left;
  height: 100%;
  margin-right: 5px;
}
.list ul .yuanli:hover:before {
  color: red;
}
.list ul .yuanli a {
  color: #000;
}
.list ul .yuanli a:hover {
  color: var(--main-color);
} */
</style>



// WEBPACK FOOTER //
// src/components/hanwei.vue